import { FORGOT_PASSWORD, ERROR } from "../actions/actionsTypes";

const forgotReducer = (state = [], action) => {
  switch (action.type) {
    case FORGOT_PASSWORD: {
      return action.payload
    }
    case ERROR: {
      return action.payload
    }
    default: {
      return state;
    }
  }
};

export default forgotReducer;



// WEBPACK FOOTER //
// ./src/reducers/forgot.js